import vehicleClient from "services/httpClient/vehicleClients";
import {
  CancelDeviceProp,
  DeviceInfoProp,
  DeviceRequestInfoProp,
  DeviceVariationProp,
  EquityDeviceProp,
  DevicePaginationProp,
  SendDeviceProp,
  SendDeviceRequest,
  RepaymentProp,
} from "styles/types/device";
// Device-finance apis

export const getEligibleDevices = (data:any) => {
  return vehicleClient.get(`/api/DeviceFinance/get-eligible-devices?page=${data.pageNumber}&limit=${data.pageSize}&searchQuery=${data.searchQuery}`);
};

export const getDeviceInfo = (data: DeviceInfoProp) => {
  return vehicleClient.get(
    `/api/DeviceFinance/get-device-info/${data.Id}/${data.Price}`
  );
};

export const getDeviceVariation = (params: DeviceVariationProp) => {
  return vehicleClient.get(`/api/DeviceFinance/get-device-variation?name=${params.name}&color=${params.color}&rom=${params.rom}&ram=${params.ram}`)
};

export const calculateRepayment = (payload:RepaymentProp) => {
  return vehicleClient.post(
    `/api/DeviceFinance/calculate-repayment`,payload
  );
};

export const sendDeviceRequest = (payload: SendDeviceProp) => {
  return vehicleClient.post("/api/DeviceFinance/send-device-request", payload);
};

export const cancelDeviceRequest = (payload: CancelDeviceProp) => {
  return vehicleClient.post(
    "/api/DeviceFinance/cancel-device-request",
    payload
  );
};

export const getEquityContribution = (payload: EquityDeviceProp) => {
  return vehicleClient.post(
    "/api/Loan/equity-contribution",
    payload
  );
};

export const getDeviceRequestHistory = (data:DevicePaginationProp) => {
  return vehicleClient.get(`/api/DeviceFinance/device-request-history?page=${data.pageNumber}&limit=${data.pageSize}&searchQuery=${data.searchQuery}`);
};

export const getDeviceRequestInfo = (params: DeviceRequestInfoProp) => {
  return vehicleClient.get("/api/DeviceFinance/device-request-info", {
    params: params,
  });
};

export const getDeviceImage = (id: number) => {
  return vehicleClient.get(`/api/DeviceFinance/device-image/${id}`,{
    responseType: 'blob',
  });
};

export const getDevicePdf = (pdfUrl: string) => {
  return vehicleClient.get("/api/DeviceFinance/device-pdf");
};
